import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import "./SearchCondition.css";
import { List } from "antd-mobile";
import { DatePicker } from 'antd';
import {
    doClearSearchConditionForFuzzy, doFillRectangleForSearchCondition,
    getAllCountiesByCityName,
    getZoneDistrictTotal,
    getZoneDistrictTotalByCity, getZonesCountByCondition, handleClickAddressItem,
    refreshCityName,
    refreshSearchCondition,
    refreshSearchMapSelectedDistrictList,
    refreshZoneMapShowPointFlag, searchBrandList,
    searchMapZoneList,
    searchZoneListView
} from "../../../../actions/ZoneAction";
import ArrowDropDownOutlinedIcon from '@material-ui/icons/ArrowDropDownOutlined';
import ArrowDropUpOutlinedIcon from '@material-ui/icons/ArrowDropUpOutlined';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ListIcon from '@material-ui/icons/List';
import {
    BUILDING_BUSINESS_TYPE,
    BUILDING_FIRE_RATING,
    BUILDING_PLATFORM_FLAG,
    BUILDING_TYPES,
    BUILDING_UNLOADING_TYPE, FuzzySearchType,
    MapSearchRangeEnums, SearchConditionTypeEnums,
    ZoneSortEnums
} from "../../../../Enums";
import MapIcon from '@material-ui/icons/Map';
import { RoutePath } from "../../../../../../constants/RoutePath";
import HttpUtils from "../../../../../../utils/HttpUtils";
import {
    Button,
    Drawer,
    Badge,
    Tab,
    Tabs,
    TextField,
    Divider,
    Chip,
    ListItem,
    ListItemText,
    MenuItem,
    RadioGroup,
    FormControlLabel,
    Radio,
} from '@material-ui/core';
import { Select, Input } from "antd";
import CheckableTagList from "./CheckableTagList";
// import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
// import DateFnsUtils from '@date-io/date-fns';
// import zhLocale from "date-fns/locale/zh-CN";
import moment from "moment";
import 'moment/locale/zh-cn';

import CityTabs from "./CityTabs";
import { FORMAT_DATE_YEAR_MONTH_SIMPLE } from "../../../../../../constants/DateTimeFormats";
import locale from "antd/es/date-picker/locale/zh_CN";

import { CACHE_ACCESS_TOKEN, CACHE_SESSION_USER } from "../../../../../../constants/Profile";
import { getSearchConditionDictApi } from '../../../../WebService';
import vipPng from '../../../../../../images/home/vip2.png'

import { message } from "antd";

class SearchCondition extends Component {

    constructor(props) {
        super(props);

        this.state = {
            formatMessage: this.props.intl['formatMessage'],
            open: false,
            type: "",

            selectType: SearchConditionTypeEnums.Enum.Default,
            sortType: ZoneSortEnums.Enum.recommendOrder,
            showDrawerFlag: false,
            locationTabIndex: 0,
            token: null,
            areaTypeDict: []
        }
    }

    componentWillMount() {
        this.setState({
            token: localStorage.getItem(CACHE_ACCESS_TOKEN)
        })
        this.props.dispatch(searchBrandList());
        this.getDict()
    }

    getDict() {
        HttpUtils.post(getSearchConditionDictApi, null, (res) => {
            this.setState({
                areaTypeDict: res.data.areaTypeDict
            })
        })
    }

    _handleChange(name, value) {
        const searchCondition = Object.assign({}, this.props.searchCondition);
        searchCondition[name] = value.target ? value.target.value : value;
        if (name === 'mapSearchRange') {
            if (searchCondition.searchFuzzyType !== FuzzySearchType.Enums.Location) {
                searchCondition.rectangleCenterPointLat = this.props.currentLocation.lat;
                searchCondition.rectangleCenterPointLng = this.props.currentLocation.lng;


                searchCondition.sortField = "distance_order";
                searchCondition.sortType = "asc";
                searchCondition.recommendOrderFlag = 0;


                // doFillRectangleForSearchCondition(searchCondition, {lat:searchCondition.rectangleCenterPointLat,lng: searchCondition.rectangleCenterPointLng}, searchCondition.mapSearchRange);

            }
            // rectangleCenterPointLat
        }
        this.props.dispatch(refreshSearchCondition(searchCondition));
    }

    _handleChangeWithSearch(name, value) {
        const searchCondition = Object.assign({}, this.props.searchCondition);
        searchCondition[name] = value.target ? value.target.value : value;

        this.props.dispatch(refreshSearchCondition(searchCondition));
        this._handleDoSearch(searchCondition)
    }


    _handleSearchTypeClick(type) {
        if (type === this.state.selectType) {
            this._handleCloseSearchSelectArea();
        } else {
            this.setState({ selectType: type, showDrawerFlag: true });
        }
    }

    _handleClearFuzzySearchTypeInfo() {

        const searchCondition = Object.assign({}, this.props.searchCondition);
        doClearSearchConditionForFuzzy(searchCondition);

        this._handleDoSearch(searchCondition);

    }

    _handleCloseSearchSelectArea() {
        this.setState({ selectType: "", showDrawerFlag: false })
    }

    _handleDoSearch(searchCondition) {
        if (searchCondition === undefined) {
            searchCondition = this.props.searchCondition ? this.props.searchCondition : {};
        }
        if (this.props.inList) {
            this.props.dispatch(searchZoneListView(searchCondition, [], this.props.zoneCoordinateMap, this.state.formatMessage, true));
        }
        else {
            this.props.dispatch(searchMapZoneList(searchCondition, this.props.zoneCoordinateMap, this.props.selectedZoneId));
            this.props.dispatch(getZoneDistrictTotal(searchCondition));

        }

    }

    _handleCheckConditionDate(searchCondition) {
        if (searchCondition.zoneDeliverDate && searchCondition.zoneDeliverDate !== '') {
            return true;
        }
        return false;
    }

    _handleClearConditionDate(searchCondition) {

        searchCondition.zoneDeliverDate = '';
    }

    _handleCheckConditionFuzzy(searchCondition) {

        if (searchCondition.searchFuzzyType && searchCondition.searchFuzzyType !== FuzzySearchType.Enums.Default) {
            return true;
        }
        return false;
    }

    _handleClearConditionFuzzy(searchCondition) {

        doClearSearchConditionForFuzzy(searchCondition);
    }

    render() {
        const { cityName, searchCondition } = this.props;
        let thisList = null;

        let sortList = ZoneSortEnums.NoDistanceList;
        let filter = sortList.map(key => ZoneSortEnums.Map[key]).filter((item) =>
            item.sortField === searchCondition.sortField && item.sortType === searchCondition.sortType);

        let sortValue = undefined;
        let sortLabel = "请选择排序";
        if (filter.length > 0) {
            sortLabel = filter[0].label;
            sortValue = filter[0].value;
        }
        let drawerClassName = "show-drawer";
        if (this.state.selectType === SearchConditionTypeEnums.Enum.Sort) {
            thisList = this._renderSortList(sortValue);
        } else if (this.state.selectType === SearchConditionTypeEnums.Enum.Location) {
            thisList = this._renderLocationView(sortValue);
        }
        else if (this.state.selectType === SearchConditionTypeEnums.Enum.Area) {
            thisList = this._renderRentAreaView();
        } else if (this.state.selectType === SearchConditionTypeEnums.Enum.BuildingInfo) {
            thisList = this._renderBuildingInfoView();
        } else if (this.state.selectType === SearchConditionTypeEnums.Enum.CitySelect) {
            thisList = this._renderCityView();
            drawerClassName = " show-drawer show-drawer-city";
        }
        let hasSortCondition = this._handleCheckConditionSort(searchCondition);
        let hasLocationCondition = this._handleCheckConditionLocation(searchCondition);
        let hasAreaCondition = this._handleCheckConditionArea(searchCondition);
        let hasBuildingCondition = this._handleCheckConditionBuildingInfo(searchCondition);
        let hasDateCondition = this._handleCheckConditionDate(searchCondition);
        let hasFuzzyCondition = this._handleCheckConditionFuzzy(searchCondition);

        let hasCondition = hasSortCondition || hasLocationCondition || hasAreaCondition || hasBuildingCondition || hasDateCondition || hasFuzzyCondition;
        return (
            <div>
                <div className="search-condition-box">
                    <div className="search-condition-part1-box">
                        <div
                            className={"search-condition-city-item-box  " + (this.props.showCityTopLevel ? "show-top-z-index" : "")}
                            onClick={() => this._handleSearchTypeClick("citySelect")}>
                            <div className="search-condition-city-name"><LocationOnIcon /><span>{cityName}</span></div>
                            <div> 切换城市</div>
                        </div>
                        <div className="search-condition-input-box">

                            {/*<Input placeholder={"请输入品牌/子市场-乡镇/地址"}/>*/}


                            {/*<Paper component="form">*/}
                            <div className="search-condition-date-input">
                                <div> 起租时间</div>
                                <DatePicker
                                    inputReadOnly={true}
                                    picker="month" bordered={false}
                                    disabledDate={(current) => current && current <= moment().startOf('month')}

                                    local={locale} allowClear={false}
                                    suffixIcon={null}
                                    placeholder={"选择日期"}
                                    value={searchCondition.zoneDeliverDate ? moment(searchCondition.zoneDeliverDate, FORMAT_DATE_YEAR_MONTH_SIMPLE) : null}
                                    onOpenChange={(open) => {
                                        if (open) {
                                            this._handleCloseSearchSelectArea();
                                        }
                                    }}
                                    onChange={(value, dateString) => {
                                        let _value = value ? value.format(FORMAT_DATE_YEAR_MONTH_SIMPLE) + '01' : ''
                                        this._handleChangeWithSearch("zoneDeliverDate", _value)
                                    }}
                                />

                                {/*</MuiPickersUtilsProvider>*/}
                            </div>
                            <Divider orientation="vertical" flexItem />
                            <div
                                className="search-condition-brand-input"
                                // value={searchCondition.fuzzy}
                                placeholder="请输入品牌/子市场-乡镇"
                                onClick={() => {
                                    if (!this.state.token) {
                                        return this.props.router.navigate({
                                            pathname: `/login`,
                                            search: `?redirect=${encodeURIComponent(window.location.pathname)}`,
                                        })
                                    }
                                    this.props.router.navigate(RoutePath.WMS_ZONE_SEARCH_FUZZY.path)
                                }}

                            >

                                {searchCondition.searchFuzzyType && searchCondition.searchFuzzyType !== FuzzySearchType.Enums.Default ?

                                    <Chip
                                        // variant="outlined"
                                        size="small"
                                        // avatar={<Avatar alt="Natacha" src="/static/images/avatar/1.jpg" />}
                                        label={FuzzySearchType.Map[searchCondition.searchFuzzyType].label + ": " + searchCondition.searchFuzzyInfo}
                                        onDelete={() => this._handleClearFuzzySearchTypeInfo()}
                                    />
                                    : <span className="search-condition-brand-input-placeholder">请输入品牌/子市场-乡镇 </span>
                                }
                            </div>

                            {/*</Paper>*/}


                        </div>


                        {this.props.inList ? <div className="search-condition-map-box"
                            onClick={() => {
                                this._handleGoToMap();
                            }}><MapIcon />
                            <div>地图</div>
                        </div> :
                            <div className="search-condition-map-box"
                                onClick={() => {
                                    this._handleGoToList();
                                }}><ListIcon />
                                <div>列表</div>
                            </div>}

                    </div>
                    <div className="search-condition-part2-box">

                        <div className="search-condition-sort-item-box">
                            <div className="search-condition-sort-item">
                                <Badge overlap="rectangular" color="secondary" variant="dot"
                                    invisible={!hasSortCondition}>
                                    <div className="show-label"
                                        onClick={() => this._handleSearchTypeClick(SearchConditionTypeEnums.Enum.Sort)}>{sortLabel}</div>
                                    {this.state.selectType === SearchConditionTypeEnums.Enum.Sort ?
                                        <ArrowDropUpOutlinedIcon /> :
                                        <ArrowDropDownOutlinedIcon />}
                                </Badge></div>

                        </div>

                        <div className="search-condition-sort-item-box">
                            <div className="search-condition-sort-item">
                                <Badge overlap="rectangular" color="secondary" variant="dot"
                                    invisible={!hasLocationCondition}>
                                    <div className="show-label"
                                        onClick={() => this._handleSearchTypeClick(SearchConditionTypeEnums.Enum.Location)}>
                                        位置区域

                                    </div>
                                    {this.state.selectType === SearchConditionTypeEnums.Enum.Location ?
                                        <ArrowDropUpOutlinedIcon /> :
                                        <ArrowDropDownOutlinedIcon />} </Badge>
                            </div>

                        </div>
                        <div className="search-condition-sort-item-box">
                            <div className="search-condition-sort-item">
                                <Badge overlap="rectangular" color="secondary" variant="dot"
                                    invisible={!hasAreaCondition}>
                                    <div className="show-label"
                                        onClick={() => this._handleSearchTypeClick(SearchConditionTypeEnums.Enum.Area)}>需求面积<br />及租金
                                    </div>
                                    {this.state.selectType === SearchConditionTypeEnums.Enum.Area ?
                                        <ArrowDropUpOutlinedIcon /> :
                                        <ArrowDropDownOutlinedIcon />}
                                </Badge></div>

                        </div>

                        <div className="search-condition-sort-item-box">
                            <div className="search-condition-sort-item">
                                <Badge overlap="rectangular" color="secondary" variant="dot"
                                    invisible={!hasBuildingCondition}>
                                    <div className="show-label"
                                        onClick={() => this._handleSearchTypeClick(SearchConditionTypeEnums.Enum.BuildingInfo)}>物业规格
                                    </div>
                                    {this.state.selectType === SearchConditionTypeEnums.Enum.BuildingInfo ?
                                        <ArrowDropUpOutlinedIcon /> :
                                        <ArrowDropDownOutlinedIcon />}
                                </Badge></div>

                        </div>
                    </div>
                    <Drawer
                        PaperProps={{ className: drawerClassName }}
                        variant="persistent"
                        anchor={"top"}
                        open={this.state.showDrawerFlag}
                    > {thisList}</Drawer>


                </div>
                {hasCondition ? <div className="search-condition-all-clear-box"
                    onClick={() => this._handleClearConditionAll()}> 全部重置</div> : null}
            </div>
        );
    }
    _handleGoToList() {
        // if (window.__wxjs_environment === 'miniprogram') {
        //     //使用navigateTo跳转到小程序路径中
        //     window.wx.miniProgram.navigateTo({
        //         url: '/modules/wms/views/zone/list/index'
        //     })
        // }else{
        this.props.router.navigate(RoutePath.WMS_ZONE_LIST.path);

        // }
    }
    _handleGoToMap() {
        // if (window.__wxjs_environment === 'miniprogram') {
        //
        //     //使用navigateTo跳转到小程序路径中
        //     window.wx.miniProgram.navigateTo({
        //         url: '/modules/wms/views/zone/map/index'
        //     })
        // }else{
        this.props.router.navigate(RoutePath.WMS_ZONE_MAP.path);

        // }
    }

    //第一个查询条件的排序
    _handleChangeSort(sortItem) {

        const user = JSON.parse(localStorage.getItem(CACHE_SESSION_USER)) || {}
        let isTemporaryVip = this.props.temporaryVipStatus === '3'
        let disabled = !user || !(this.props.authStatus || isTemporaryVip)
        if (disabled) {
            return message.info('登录并认证后可使用该功能');
        }


        const searchCondition = Object.assign({}, this.props.searchCondition);
        let type = sortItem.value;
        if (sortItem === undefined) {
            searchCondition.recommendOrderFlag = 1;
        } else {
            searchCondition.recommendOrderFlag = 0;
        }
        const data = ZoneSortEnums.Map[type];
        searchCondition.sortField = data.sortField;
        searchCondition.sortType = data.sortType;
        this._handleDoSearch(searchCondition);


        this._handleCloseSearchSelectArea();
    }

    _handleCheckConditionSort(searchCondition) {
        let ZoneSortEnumsItem = ZoneSortEnums.List.find((item) => {
            return item.sortField === searchCondition.sortField
        })

        if (searchCondition.sortField && ZoneSortEnumsItem && ZoneSortEnums.NoDistanceList.includes(ZoneSortEnumsItem.value)) {
            return true;
        }
        return false;
    }

    _handleClearConditionAll() {

        const condition = Object.assign({}, this.props.searchCondition);
        this._handleClearConditionSort(condition);
        this._handleClearConditionLocation(condition);
        this._handleClearConditionArea(condition);
        this._handleClearConditionBuildingInfo(condition);
        this._handleClearConditionDate(condition);
        this._handleClearConditionFuzzy(condition);

        this._handleDoSearch(condition)
    }

    _handleClearConditionSort(searchCondition) {
        searchCondition.sortField = '';
        searchCondition.sortType = '';
        searchCondition.recommendOrderFlag = 1;
    }

    _renderSortList(sortValue) {
        return <List className="search-sort-list">
            {ZoneSortEnums.NoDistanceList.map((key, index) => {
                let item = ZoneSortEnums.Map[key];
                return <ListItem button key={key} selected={sortValue === item.value}
                    onClick={() => this._handleChangeSort(item)}>
                    <ListItemText primary={item.label} />
                    <img src={vipPng} className='sortListVipIcon' />
                </ListItem>
            }
            )}
        </List>
    }

    //第一个查询条件的排序
    _handleChangeLocationTabIndex(index, e) {
        this.setState({ locationTabIndex: index })
    }

    _handleDistrictChange(checked, district) {
        let zoneDistrictList = Object.assign([], this.props.selectedDistrictList);

        if (checked) {
            if (!zoneDistrictList.includes(district)) {
                zoneDistrictList.push(district);
            }
        } else {
            zoneDistrictList = zoneDistrictList.filter((item) => item !== district);
        }
        this.props.dispatch(refreshSearchMapSelectedDistrictList(zoneDistrictList));
        const searchCondition = Object.assign({}, this.props.searchCondition);
        if (this.props.inList) {
            searchCondition.zoneDistrictList = zoneDistrictList;
            this.props.dispatch(searchZoneListView(searchCondition, [], this.props.zoneCoordinateMap, this.state.formatMessage));
        }

    }


    _handleCheckConditionLocation(searchCondition) {
        if (searchCondition.mapSearchRange && searchCondition.mapSearchRange !== '') {
            return true;
        } else {
            let selectedDistrictList = this.props.selectedDistrictList;
            if (selectedDistrictList && selectedDistrictList.length > 0) {
                return true;
            }
        }
        return false;
    }

    _handleClearConditionLocation(searchCondition) {

        searchCondition.selectedDistrictList = [];
        searchCondition.mapSearchRange = '';
        searchCondition.rectangleCenterPointLat = '';
        searchCondition.rectangleCenterPointLng = '';

        this.props.dispatch(refreshSearchMapSelectedDistrictList([]));
    }

    _renderLocationView() {
        let existZoneDistrict = this.props.zoneDistrictTotal ? this.props.zoneDistrictTotal : [];
        let districtList = this.props.selectedDistrictList ? this.props.selectedDistrictList : [];
        let searchCondition = this.props.searchCondition ? this.props.searchCondition : {};

        return <div className="search-condition-form-container">
            <div className="search-condition-tab-container">
                <Tabs className="search-condition-tab"
                    orientation="vertical"
                    variant="standard"
                    value={this.state.locationTabIndex}
                    onChange={(e, index) => this._handleChangeLocationTabIndex(index, e)}
                    aria-label="Vertical tabs example"
                // className={classes.tabs}
                >
                    <Tab label="行政区" />
                    <Tab label="直线距离" /></Tabs>

                <List hidden={this.state.locationTabIndex !== 0} className="search-condition-tab-list">
                    {existZoneDistrict.map((item, index) => {
                        let selected = districtList && districtList.includes(item.district);
                        return <ListItem button key={item.value}
                            selected={selected}
                            onClick={() => this._handleDistrictChange(!selected, item.district)}>
                            <ListItemText primary={item.district} />

                        </ListItem>
                    })}
                </List>

                <List hidden={this.state.locationTabIndex !== 1} className="search-condition-tab-list">
                    {this.props.inList ? <div>{MapSearchRangeEnums.List.map((enumItem, index) => {
                        let selected = searchCondition && searchCondition.mapSearchRange === enumItem.value;
                        return <ListItem button key={enumItem.value}
                            selected={selected}
                            onClick={() => this._handleChange("mapSearchRange", enumItem.value)}>
                            <ListItemText primary={enumItem.label} />

                        </ListItem>
                    })}</div> : <div className="list-message">默认是地图范围</div>}
                </List>
            </div>
            <div className="search-condition-form-button-area">
                <Button variant="contained"
                    onClick={() => {
                        const condition = Object.assign({}, this.props.searchCondition);
                        this._handleClearConditionLocation(condition);
                        this.props.dispatch(refreshSearchCondition(condition));
                    }}>清空 </Button>
                <Button variant="contained" color="primary"
                    onClick={() => {

                        let zoneDistrictList = Object.assign([], this.props.selectedDistrictList);

                        if (this.props.inList) {
                            searchCondition.zoneDistrictList = zoneDistrictList;
                            /*
                            this.props.dispatch(getZonesCountByCondition({
                                                            zoneCity: this.props.cityName,
                                                            withoutBasicCondition: true,
                                                            mapSearchRange: searchCondition.mapSearchRange,
                                                            rectangleCenterPointLng: searchCondition.rectangleCenterPointLng,//西
                                                            rectangleCenterPointLat: searchCondition.rectangleCenterPointLat,//东
                            
                                                        }));
                            */

                            this._handleDoSearch(searchCondition)
                        }




                        this._handleCloseSearchSelectArea();
                    }}> 完成 </Button>
            </div>
        </div>
    }

    _handleCheckConditionArea(searchCondition) {
        // if (searchCondition.zoneMinVacantArea && searchCondition.zoneMinVacantArea !== '') {
        //     return true;
        // }
        if (searchCondition.needAreaList && searchCondition.needAreaList.length > 0) {
            return true;
        }
        if (searchCondition.maxRentEffective && searchCondition.maxRentEffective !== '') {
            return true;
        }
        if (searchCondition.minRentEffective && searchCondition.minRentEffective !== '') {
            return true;
        }

        return false;
    }

    _handleClearConditionArea(searchCondition) {
        // searchCondition.zoneMinVacantArea = '';
        searchCondition.needAreaList = [];

        searchCondition.maxRentEffective = '';
        searchCondition.minRentEffective = '';
    }

    _renderRentAreaView() {
        let searchCondition = this.props.searchCondition ? this.props.searchCondition : {};

        const user = JSON.parse(localStorage.getItem(CACHE_SESSION_USER)) || {}
        let isTemporaryVip = this.props.temporaryVipStatus === '3'
        let disabled = !user || !(this.props.authStatus || isTemporaryVip)
        let needAreaList = searchCondition.needAreaList || []
        return <div className="search-condition-form-container">
            <div className="search-condition-form-item" onClick={() => {
                if (disabled) {
                    message.info('登录并认证后可使用该功能');
                }
            }}>
                <span className="search-condition-form-item-label">
                    需求面积<br />(m²)
                    <img src={vipPng} className='vipIcon' />
                </span>
                <div className="search-condition-form-item-input">
                    <Select
                        placeholder="请选择空置面积"
                        disabled={disabled}
                        className="search-condition-form-item-input-number"
                        mode="multiple"
                        value={needAreaList}
                        onChange={(value) => this._handleChange('needAreaList', value)}
                    >
                        {
                            this.state.areaTypeDict.map(item => {
                                return <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>
                            })
                        }
                    </Select>
                    {/* <TextField className="search-condition-form-item-input-number"
                        value={searchCondition.zoneMinVacantArea}
                        onChange={(value) => this._handleChange('zoneMinVacantArea', value)}
                        placeholder="请输入需求面积至少满足多少m²" inputProps={{ inputMode: 'decimal' }}
                    /> */}
                </div>

            </div>
            <div className="search-condition-form-item" onClick={() => {
                if (disabled) {
                    message.info('登录并认证后可使用该功能');
                }
            }}>
                <span className="search-condition-form-item-label">租金范围<br />(元/m²/天) <img src={vipPng} className='vipIcon' /></span>
                <div className="search-condition-form-item-input">
                    <Input className="search-condition-form-item-input-number"
                        value={searchCondition.minRentEffective}
                        disabled={disabled}
                        onChange={(value) => this._handleChange('minRentEffective', value)}
                        placeholder="请输入最小预算值" inputProps={{ inputMode: 'decimal' }}
                    />
                    ~
                    <Input className="search-condition-form-item-input-number"
                        value={searchCondition.maxRentEffective}
                        disabled={disabled}
                        onChange={(value) => this._handleChange('maxRentEffective', value)}
                        placeholder="请输入最大预算值" inputProps={{ inputMode: 'decimal' }}
                    />
                </div>

            </div>
            <div className="search-condition-form-button-area">
                <Button variant="contained"
                    onClick={() => {
                        const condition = Object.assign({}, this.props.searchCondition);
                        this._handleClearConditionArea(condition);
                        this.props.dispatch(refreshSearchCondition(condition));
                    }}>清空 </Button>
                <Button variant="contained" color="primary"
                    onClick={() => {
                        this._handleDoSearch();
                        this.setState({ selectType: "", showDrawerFlag: false })
                    }}> 完成 </Button>
            </div>
        </div>
    }

    _handleTagChange(checked, name, value) {
        const searchCondition = Object.assign({}, this.props.searchCondition);
        const dataList = searchCondition[name] ? searchCondition[name] : [];
        let nextSelectedTags;

        if (name === "platformFlag") {
            nextSelectedTags = "";
            if (value !== "-1") {
                nextSelectedTags = checked ? value : "";
            }
        } else {
            nextSelectedTags = [];
            //判断是否为不限，不是的话替换原来的展示数据
            if (value !== "-1") {
                nextSelectedTags = checked ? [...dataList, value] : dataList.filter(t => t !== value);
            }
        }
        searchCondition[name] = nextSelectedTags;

        this.props.dispatch(refreshSearchCondition(searchCondition));

    }

    _handleCheckConditionBuildingInfo(searchCondition) {
        if (searchCondition.buildingTypeList && searchCondition.buildingTypeList.length > 0) {
            return true;
        }
        // if (searchCondition.businessTypeList && searchCondition.businessTypeList.length > 0) {
        //     return true;
        // }
        if (searchCondition.fireRatingList && searchCondition.fireRatingList.length > 0) {
            return true;
        }
        if (searchCondition.unloadingTypeList && searchCondition.unloadingTypeList.length > 0) {
            return true;
        }
        if (searchCondition.platformFlag && searchCondition.platformFlag !== "") {
            return true;
        }
        return false;
    }

    _handleClearConditionBuildingInfo(searchCondition) {
        searchCondition.buildingTypeList = [];
        // searchCondition.businessTypeList = [];
        searchCondition.fireRatingList = [];
        searchCondition.unloadingTypeList = [];
        searchCondition.platformFlag = "";
    }

    _renderBuildingInfoView() {
        let searchCondition = this.props.searchCondition ? this.props.searchCondition : {};
        return <div className="search-condition-form-container">
            <div className="search-condition-form-item">
                <span className="search-condition-form-item-label">建筑类型<br />(可多选)</span>
                <div className="checkable-tag-container">
                    <CheckableTagList dataList={BUILDING_TYPES.List}
                        space={true}
                        hasUnlimit={false}
                        value={searchCondition.buildingTypeList}
                        onChange={(checked, value) => this._handleTagChange(checked, "buildingTypeList", value)}
                    />
                </div>

            </div>
            {/* <div className="search-condition-form-item">
                <span className="search-condition-form-item-label">用途<br />(可多选) </span>
                <div className="checkable-tag-container">
                    <CheckableTagList dataList={BUILDING_BUSINESS_TYPE.List}
                        space={true}
                        hasUnlimit={false}
                        value={searchCondition.businessTypeList}
                        onChange={(checked, value) => this._handleTagChange(checked, "businessTypeList", value)}
                    />
                </div>

            </div> */}
            <div className="search-condition-form-item">
                <span className="search-condition-form-item-label">耐火等级<br />(可多选) </span>
                <div className="checkable-tag-container">
                    <CheckableTagList dataList={BUILDING_FIRE_RATING.List}
                        space={true}
                        hasUnlimit={true}
                        value={searchCondition.fireRatingList}
                        onChange={(checked, value) => this._handleTagChange(checked, "fireRatingList", value)}
                    />
                </div>

            </div>
            <div className="search-condition-form-item">
                <span className="search-condition-form-item-label">卸货方式<br />(可多选) </span>
                <div className="checkable-tag-container">
                    <CheckableTagList dataList={BUILDING_UNLOADING_TYPE.List}
                        space={true}
                        hasUnlimit={true}
                        value={searchCondition.unloadingTypeList}
                        onChange={(checked, value) => this._handleTagChange(checked, "unloadingTypeList", value)}
                    />
                </div>

            </div>
            <div className="search-condition-form-item">
                <span className="search-condition-form-item-label">月台有无 </span>
                <div className="checkable-tag-container">
                    <CheckableTagList dataList={BUILDING_PLATFORM_FLAG.List}
                        space={true}
                        hasUnlimit={true}
                        value={searchCondition.platformFlag}
                        onChange={(checked, value) => this._handleTagChange(checked, "platformFlag", value)}
                    />
                </div>

            </div>
            <div className="search-condition-form-button-area">
                <Button variant="contained"
                    onClick={() => {
                        const condition = Object.assign({}, this.props.searchCondition);

                        this._handleClearConditionBuildingInfo(condition);

                        this.props.dispatch(refreshSearchCondition(condition));
                    }}>清空 </Button>
                <Button variant="contained" color="primary"
                    onClick={() => {
                        this._handleDoSearch();
                        this.setState({ selectType: "", showDrawerFlag: false })
                    }}> 完成 </Button>
            </div>
        </div>
    }

    _renderCityView() {

        return <div className="search-condition-form-container">
            <CityTabs onClick={(value) => this._handleSelectCity(value)} />

        </div>
    }

    _handleClickAddressItem(addrItem) {
        const searchCondition = Object.assign({}, this.props.searchCondition);
        handleClickAddressItem(this.props.cityName, addrItem, searchCondition, this.props.dispatch);
        this._handleDoSearch(searchCondition)

    }

    _handleSelectCity(cityName) {
        //更新当前城市
        this.props.dispatch(refreshCityName(cityName));

        const searchCondition = Object.assign({}, this.props.searchCondition);
        if (this.props.inList) {
            searchCondition.zoneDistrictList = [];

        } else {
            searchCondition.zoneDistrictList = [];

        }

        searchCondition.pageSize = 20;
        searchCondition.zoneCity = cityName;
        searchCondition.recommendOrderFlag = 1;
        //查询当前城市所有的行政区域内仓库总数
        this.props.dispatch(getZoneDistrictTotalByCity(cityName));
        this.props.dispatch(refreshSearchMapSelectedDistrictList([]));
        this.props.dispatch(refreshSearchCondition(searchCondition));

        if (this.props.inList) {
            this.props.dispatch(searchZoneListView(searchCondition, [], this.props.zoneCoordinateMap, this.state.formatMessage, true));//列表
        } else {
            this.props.dispatch(searchMapZoneList(searchCondition, []));//列表
            this.props.dispatch(getZoneDistrictTotal(searchCondition));
            this.props.dispatch(getAllCountiesByCityName(cityName));
            this.props.dispatch(refreshZoneMapShowPointFlag(false));

            if (this.props.changeMapFunction) {
                this.props.changeMapFunction.call(this, cityName)
            }
        }
        this._handleCloseSearchSelectArea()

    }

}

function mapStateToProps(store) {
    return {
        searchCondition: store.WMSZoneReducer.searchCondition,
        zoneCoordinateMap: store.WMSZoneReducer.zoneCoordinateMap,
        cityName: store.WMSZoneReducer.cityName,
        zoneDistrictTotal: store.WMSZoneReducer.zoneDistrictTotal,
        selectedDistrictList: store.WMSZoneReducer.selectedDistrictList,
        currentLocation: store.WMSZoneReducer.currentLocation,
        selectedZoneId: store.WMSZoneReducer.currentLocation,
        temporaryVipStatus: store.UserReducer.temporaryVipStatus,
        authStatus: store.UserReducer.authStatus,
        UserReducer: store.UserReducer,

    }
}

export default connect(mapStateToProps)(injectIntl(SearchCondition));